import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-member-link-source',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  templateUrl: './member-link-source.component.html',
  styleUrl: './member-link-source.component.scss',
})
export class MemberLinkSourceComponent {
  @Input() personId: string | null | undefined;

  get isSystemMember(): boolean {
    return !!this.personId;
  }
}
